var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.bussinesList),function(status){return _c('div',{key:status.name},[(status.bussinesStatusList.length > 0)?_c('bussines-status-card',{attrs:{"status":status,"EventBus":_vm.EventBus}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }